export default "__VITE_ASSET__UO_CFZYO__"